<template lang="html">
    <h1 class="main-heading"><slot></slot></h1>
</template>

<script>
export default {
    name: "MainHeading",
};
</script>

<style scoped>
.main-heading {
    color: #202020;
    letter-spacing: 0.05em;
    line-height: 0.8;
    font-size: min(3.5rem, 15vw);
    font-weight: 500;
}
</style>
